import React, { useEffect, useState } from "react";
import { Typography, Tabs, Tab, Avatar, Box } from "@mui/material";
import { deadlinesData } from "./dummyDataForDeadline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import JulienImage from "../../assets/Julien.png";
import instance from "../../apiServices/instance";

const COMPANY_HOUSE_API_KEY = process.env.REACT_APP_COMPANIES_HOUSE_API_KEY;
const COMPANY_HOUSE_API_URL = process.env.REACT_APP_COMPANY_HOUSE_API_URL;

const accountants = {
  business: {
    name: "Julien Smith",
    location: "London Office",
  },
  personal: {
    name: "Julien Smith",
    location: "London Office",
  },
};

function formatDate(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${getOrdinal(day)} ${month} ${year}`;
}

const Deadlines = () => {
  const [selectedTab, setSelectedTab] = useState("business");
  const [companyDetailsFound, setCompanyDetailsFound] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deadlines, setDeadlines] = useState(deadlinesData);

  const accountant = accountants[selectedTab];

  const getDeadlines = async () => {
    const companyName = localStorage.getItem("companyName");
    setLoading(true);
    try {
      const companyProfileDetails = await instance.get(
        `api/company-info/${companyName}/company-house-details`
      );

      const companyInfo = companyProfileDetails.data.data;
      if (companyProfileDetails?.data) {
        setCompanyDetailsFound(true);
      }

      const newDeadlines = deadlines.map((section) => {
        if (section.tab === "business" && section.type === "Action Required") {
          return {
            ...section,
            data: [
              {
                item: "Year End Accounts",
                madeUpToDate: companyInfo.accounts.last_accounts.made_up_to,
                dueDate: companyInfo.accounts.last_accounts.period_end_on,
                action: "Speak to Accountant",
              },
            ],
          };
        }

        return section;
      });

      setDeadlines(newDeadlines);
    } catch (error) {
      setCompanyDetailsFound(false);
      console.error("Error fetching deadlines:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDeadlines();
  }, []);
  if (loading) {
    return (
      <Box
        display="flex"
        sx={{
          height: "100vh",
          backgroundColor: "#F6F5F8",
          color: "#2F2D3B",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box sx={{ padding: "3rem", display: "flex" }}>
            <Typography
              sx={{ color: "#0F0049", marginBottom: "2rem" }}
              variant="h4"
              fontWeight="bold"
            >
              Loading...
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  } else if (companyDetailsFound !== null && !companyDetailsFound) {
    return (
      <Box
        display="flex"
        sx={{
          height: "100vh",
          backgroundColor: "#F6F5F8",
          color: "#2F2D3B",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box sx={{ padding: "3rem", display: "flex" }}>
            <Typography
              sx={{ color: "#0F0049", marginBottom: "2rem" }}
              variant="h4"
              fontWeight="bold"
            >
              No Deadlines Found
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  const filteredDeadlines = deadlines.filter(
    (section) => section.tab === selectedTab
  );

  return (
    <Box
      display="flex"
      sx={{
        height: "100vh",
        backgroundColor: "#F6F5F8",
        color: "#2F2D3B",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Box sx={{ padding: "3rem", display: "flex" }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              sx={{ color: "#0F0049", marginBottom: "2rem" }}
              variant="h4"
              fontWeight="bold"
            >
              Upcoming Deadlines
            </Typography>
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Business" value="business" />
              <Tab label="Personal" value="personal" />
            </Tabs>

            {filteredDeadlines.map(({ Icon, ...section }, index) => (
              <Box
                key={index}
                sx={{
                  marginY: 2,
                  padding: 0,
                  backgroundColor: "#fff",
                  borderTopLeftRadius: "1rem",
                  borderTopRightRadius: "1rem",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      backgroundColor: section.color,
                      padding: "0.5rem 1rem",
                      borderTopLeftRadius: "1rem",
                      borderTopRightRadius: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {Icon}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        color: section.fontColor,
                      }}
                    >
                      {section.type}
                    </Typography>
                  </Box>
                  <Box sx={{ padding: "0.5rem" }}>
                    <table width="100%">
                      <thead>
                        <tr>
                          <th align="left">Item</th>
                          <th align="left">Made up to date</th>
                          <th align="left">Due Date</th>
                          <th align="left">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.data.length === 0 ? (
                          <tr
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              color: "#000",
                              padding: "1rem",
                            }}
                          >
                            <td colSpan={4}>No Data</td>
                          </tr>
                        ) : (
                          section.data.map((deadline, i) => (
                            <tr key={i}>
                              <td>{deadline.item}</td>
                              <td>{formatDate(deadline.madeUpToDate)}</td>
                              <td>{formatDate(deadline.dueDate) ?? ""}</td>
                              <td>{deadline.action}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
          <Box sx={{ width: 320, paddingLeft: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              YOUR DEDICATED ACCOUNTANT
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Avatar
                sx={{ width: 125, height: 125, marginY: 1 }}
                src={JulienImage}
              />
              <Box
                sx={{
                  display: "flex",
                  gap: "0.5rem",
                  flexDirection: "column",
                }}
              >
                <Typography variant="h5" fontWeight={900}>
                  {accountant.name}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  {accountant.location}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    alignItems: "center",
                  }}
                >
                  <p
                    onClick={() => {
                      window.open(
                        "https://meetings.hubspot.com/julien-smith",
                        "_blank"
                      );
                    }}
                    style={{
                      cursor: "pointer",
                      color: "#800080",
                    }}
                  >
                    Book a call
                  </p>
                  <OpenInNewIcon
                    sx={{
                      color: "#800080",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Deadlines;
